export default __webpack_public_path__ + "static/media/backGroundPurple.f6d5b71e.png";